var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"twitter-timeline",attrs:{"data-chrome":"nofooter transparent","data-height":"700","data-width":"500","href":_vm.link}})}
var staticRenderFns = []

export { render, staticRenderFns }